{
  "name": "alertsense",
  "version": "2.0.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "theme:tokens": "ts-node cli/theme/generate-tokens.ts",
    "theme:tokens:check": "ts-node cli/theme/generate-tokens.ts --check",
    "palette:tokens": "ts-node cli/theme/generate-palette.ts",
    "palette:tokens:check": "ts-node cli/theme/generate-palette.ts --check",
    "start": "ng serve --proxy-config ./src/config/proxy.conf.json",
    "start:localhost": "ng serve --proxy-config ./src/config/proxy.conf.json --configuration=localhost",
    "start:localhost-ssl": "ng serve --proxy-config ./src/config/proxy.conf.json --configuration=localhost-ssl",
    "start:dev": "ng serve --proxy-config ./src/config/proxy.conf.dev.json --configuration=development",
    "start:staging": "ng serve --proxy-config ./src/config/proxy.conf.staging.json --configuration=staging",
    "start:prod": "ng serve --proxy-config ./src/config/proxy.conf.prod.json --configuration=production",
    "start:mock": "ng serve --configuration=mock",
    "build": "ng build",
    "build:local": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng build --configuration=localhost --verbose=true",
    "build:prod": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng build --configuration=production --verbose=true",
    "cicd": "npm run ci:install",
    "ci:install": "npm ci --verbose=true 1>angular-install.log 2>&1 && npm rebuild node-sass",
    "ci:build": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng build --configuration=production --verbose=true 1>angular-build.log 2>&1",
    "ci:test": "ng test --browsers ChromeHeadless --source-map false --watch false --reporters junit,brief 1>angular-test.log 2>&1",
    "ci:test-lint": "ng lint --eslint-config eslint-config/ci/eslint.config.mjs 1>angular-test-lint.log 2>&1",
    "ci:accessibility-lint": "ng lint --eslint-config eslint-config/accessibility/eslint.config.mjs 1>angular-accessibility-lint.log 2>&1",
    "test:ci": "npm run ci:test",
    "test:debug": "ng test --source-map true --browsers ChromeDebug",
    "test:once": "ng test --browsers ChromeHeadless --watch false",
    "test:file": "ng test --browsers ChromeHeadless --watch false --include=\"**/*${npm_config_file}*.spec.ts\"",
    "test": "ng test",
    "lint": "ng lint",
    "test:eslint-rules": "node --test eslint-config/rules/*.test.mjs",
    "lint:styles": "stylelint \"src/**/*.{css,scss}\"",
    "openapi:boxwood": "openapi-generator-cli generate -i http://localhost:5070/swagger/v1/swagger.json -g typescript-angular -o src/app/boxwood-api -c src/app/boxwood-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:directory": "openapi-generator-cli generate -i https://api-handweave.alertsense.com/swagger/Directories/swagger.json -g typescript-angular -o src/app/directory-api -c src/app/directory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:usage-local": "openapi-generator-cli generate -i http://localhost:5010/swagger/usage/swagger.json -g typescript-angular -o src/app/usage-api -c src/app/usage-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:usage": "openapi-generator-cli generate -i http://api-handweave.alertsense.com/swagger/usage/swagger.json -g typescript-angular -o src/app/usage-api -c src/app/usage-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:platform-local": "openapi-generator-cli generate -i http://localhost:5010/swagger/public/swagger.json -g typescript-angular -o src/app/platform-directory-api -c src/app/platform-directory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:platform": "openapi-generator-cli generate -i http://api-handweave.alertsense.com/swagger/public/swagger.json -g typescript-angular -o src/app/platform-directory-api -c src/app/platform-directory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:handweave": "openapi-generator-cli generate -i https://api-handweave.alertsense.com/swagger/v1/swagger.json -g typescript-angular -o src/app/handweave-api -c src/app/handweave-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:handweave-local": "openapi-generator-cli generate -i http://localhost:5010/swagger/v1/swagger.json -g typescript-angular -o src/app/handweave-api -c src/app/handweave-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:hickory": "openapi-generator-cli generate -i https://admin.alertsense.com/tamarack/swagger/swagger.json -g typescript-angular -o src/app/hickory-api -c src/app/hickory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:hickory-dev": "openapi-generator-cli generate -i https://admin.dev.alertsense.io/tamarack/swagger/swagger.json -g typescript-angular -o src/app/hickory-api -c src/app/hickory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:hickory-local": "openapi-generator-cli generate -i http://localhost:51212/tamarack/swagger/swagger.json -g typescript-angular -o src/app/hickory-api -c src/app/hickory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:hickory-json": "openapi-generator-cli generate -i ../hickory/src/App/AlertSense.Hickory.AdminWebsite/tamarack/swagger/swagger.json -g typescript-angular -o src/app/hickory-api -c src/app/hickory-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:walnut": "openapi-generator-cli generate -i https://content.alertsense.com/swagger/v1/swagger.json -g typescript-angular -o src/app/walnut/walnut-api -c src/app/walnut/walnut-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:walnut-local": "openapi-generator-cli generate -i http://localhost:5062/swagger/v1/swagger.json -g typescript-angular -o src/app/walnut/walnut-api -c src/app/walnut/walnut-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:walnut-dev": "openapi-generator-cli generate -i http://content.dev.alertsense.io/swagger/v1/swagger.json -g typescript-angular -o src/app/walnut/walnut-api -c src/app/walnut/walnut-api/openapi-config.json --type-mappings=DateTime=Date",
    "openapi:help": "openapi-generator-cli config-help -g typescript-angular",
    "openapi:elm-local": "openapi-generator-cli generate -i http://localhost:5021/swagger/v2/swagger.json -g typescript-angular -o src/app/elm-api -c src/app/elm-api/openapi-config.json",
    "cy": "cypress open --browser chrome --expose env=dev",
    "cy:local": "cypress open --browser chrome --expose env=dev --config baseUrl=http://localhost:4200",
    "cy:local-run": "cypress run --browser chrome --expose env=dev --config baseUrl=http://localhost:4200",
    "cy:dev": "cypress open --browser chrome --expose env=dev",
    "cy:dev-run": "cypress run --browser chrome --expose env=dev",
    "cy:staging": "cypress open --browser chrome --expose env=staging --config baseUrl=https://apps.staging.alertsense.io,specPattern=cypress/e2e/staging/**/*.cy.ts",
    "cy:prod": "cypress open --browser chrome --expose env=prod --config baseUrl=https://apps.alertsense.com,specPattern=cypress/e2e/prod/**/*.cy.ts",
    "browserslist-update": "npx --yes update-browserslist-db@latest",
    "mfa": "ts-node cli/mfa/cli.ts",
    "translate": "ts-node cli/translate/cli.ts",
    "translate:editor": "ts-node cli/translate/cli.ts --folder packages/rte-embed-quill/locales",
    "csp:update": "ts-node cli/csp/cli.ts update",
    "csp:show": "ts-node cli/csp/cli.ts show",
    "csp:pretty": "ts-node cli/csp/cli.ts pretty",
    "rte:publish": "npm run publish --workspaces --if-present"
  },
  "private": true,
  "workspaces": [
    "packages/*"
  ],
  "overrides": {
    "@cypress/webpack-batteries-included-preprocessor": {
      "@cypress/webpack-preprocessor": "$@cypress/webpack-preprocessor"
    }
  },
  "dependencies": {
    "@angular/animations": "^21.2.9",
    "@angular/cdk": "^21.2.7",
    "@angular/common": "^21.2.9",
    "@angular/compiler": "^21.2.9",
    "@angular/core": "^21.2.9",
    "@angular/forms": "^21.2.9",
    "@angular/google-maps": "^21.2.7",
    "@angular/material": "^21.2.7",
    "@angular/platform-browser": "^21.2.9",
    "@angular/platform-browser-dynamic": "^21.2.9",
    "@angular/platform-server": "^21.2.9",
    "@angular/router": "^21.2.9",
    "@arcgis/core": "^5.1.26",
    "@arcgis/map-components": "^5.1.26",
    "@esri/calcite-components": "^5.1.2",
    "@googlemaps/js-api-loader": "^1.16.8",
    "@googlemaps/markerclusterer": "^2.5.3",
    "@jsonforms/angular": "^3.7.0",
    "@jsonforms/angular-material": "^3.7.0",
    "@jsonforms/core": "^3.7.0",
    "@newrelic/browser-agent": "^1.314.0",
    "@openid/appauth": "^1.3.2",
    "@types/twitter-text": "^3.1.10",
    "angular-csv-ext": "^1.0.5",
    "angular-gridster2": "^21.0.1",
    "angular-l10n": "^17.0.1",
    "chart.js": "^4.5.1",
    "ckeditor4-angular": "^5.1.0",
    "core-js": "^3.46.0",
    "cron-parser": "^4.9.0",
    "cronstrue": "^2.50.0",
    "csv-writer": "^1.6.0",
    "dompurify": "^3.2.4",
    "flatpickr": "^4.6.13",
    "handlebars": "^4.7.8",
    "ical.js": "^1.5.0",
    "jquery": "^3.7.1",
    "jszip": "^3.10.1",
    "jwt-decode": "^4.0.0",
    "libphonenumber-js": "^1.10.61",
    "moment": "^2.29.4",
    "ng2-charts": "^10.0.0",
    "ngx-color-picker": "^20.1.1",
    "ngx-indexed-db": "^22.0.0",
    "ngx-mask": "^21.0.1",
    "ngx-papaparse": "^8.0.0",
    "oidc-client-ts": "^3.4.1",
    "quill": "^2.0.3",
    "quill-delta-to-html": "^0.12.1",
    "quill-table-up": "^3.5.1",
    "recordrtc": "^5.6.2",
    "rrule": "^2.7.2",
    "rxjs": "^7.8.0",
    "sms-segments-calculator": "^1.2.0",
    "survey-angular-ui": "^2.5.47",
    "survey-core": "^2.5.47",
    "survey-creator-angular": "^2.5.47",
    "survey-creator-core": "^2.5.47",
    "timezones-ical-library": "^1.8.2",
    "ts-helpers": "^1.1.2",
    "tslib": "^2.0.0",
    "twitter-text": "^3.1.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/schematics": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular-eslint/utils": "^21.3.1",
    "@angular/build": "^21.2.7",
    "@angular/cli": "^21.2.7",
    "@angular/compiler-cli": "^21.2.9",
    "@angular/language-service": "^21.2.9",
    "@angular/localize": "^21.2.9",
    "@cypress/schematic": "^5.0.0",
    "@cypress/webpack-batteries-included-preprocessor": "^4.1.1",
    "@cypress/webpack-preprocessor": "^7.1.0",
    "@eslint/js": "^9.39.5",
    "@openapitools/openapi-generator-cli": "^2.13.4",
    "@schematics/angular": "^21.2.2",
    "@types/ckeditor": "^4.9.10",
    "@types/estree": "^1.0.5",
    "@types/geojson": "^7946.0.14",
    "@types/google.maps": "^3.55.7",
    "@types/jasmine": "^5.1.4",
    "@types/jquery": "^3.5.30",
    "@types/new-relic-browser": "^1.230.4",
    "@types/node": "^20.12.7",
    "@types/quill": "^2.0.14",
    "@typescript-eslint/eslint-plugin": "^8.68.0",
    "@typescript-eslint/parser": "^8.68.0",
    "@typescript-eslint/utils": "^8.68.0",
    "angular-eslint": "^21.4.0",
    "cross-env": "^10.1.0",
    "cypress": "^15.13.0",
    "eslint": "^9.39.5",
    "eslint-plugin-custom-accessibility": "file:./packages/eslint-plugin-custom-accessibility",
    "eslint-plugin-jasmine": "^4.2.2",
    "eslint-plugin-sonarjs": "^4.2.0",
    "eslint-plugin-strict-null-checks": "^0.1.3",
    "globals": "^17.11.0",
    "jasmine-core": "^5.1.2",
    "karma": "^6.4.3",
    "karma-brief-reporter": "^0.2.2",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "otpauth": "^9.5.1",
    "postcss-scss": "^4.0.9",
    "prettier": "^3.3.3",
    "stylelint": "^16.26.1",
    "ts-node": "^10.9.1",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.68.0",
    "typescript-strict-plugin": "^2.4.4"
  },
  "optionalDependencies": {
    "fsevents": "^2.3.2"
  },
  "browser": {
    "fs": false
  }
}
